import React from "react";
import Preloader from "../helper/Preloader";
import ColorInit from "../helper/ColorInit";
import HeaderOneMain from "../components/UI/HeaderOneMain";
import Breadcrumb from "../components/UI/BreadcrumbMain";
import FooterOneMain from "../components/UI/FooterOneMain";
import BottomFooter from "../components/UI/BottomFooterMain";
import ShippingOneMain from "../components/UI/ShippingOneMain";
import ScrollToTop from "react-scroll-to-top";
import ProfileMain from "../components/UI/ProfileMain";

const CartPage = () => {
  return (
    <>
      {/* ColorInit */}
      <ColorInit color={false} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderTwo */}
      <HeaderOneMain category={false} />

      {/* Breadcrumb */}
      <Breadcrumb title={"Profile"} />

      {/* CartSection */}
      <ProfileMain />

      {/* ShippingOne */}
      <ShippingOneMain />

      {/* FooterTwo */}
      <FooterOneMain />

      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default CartPage;
